import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Constellate',
    description: "Constellate is a team of 21 AI agents that markets your product, finds leads, writes your emails and fixes your bugs. You talk to one Coordinator, and it runs the rest.",
    placeholder: "Talk to one agent. Twenty get to work.",
    url: getOrigin()
}

export const navLinks = [
    { label: 'How it works', href: '#how-it-works' },
    { label: 'Agents', href: '#agents' },
    { label: 'Example', href: '#example' },
    { label: 'FAQ', href: '#faq' }
]
